import React, { useEffect, useState } from "react";
// styled components
import { Table, Empty, Button, Input, Select } from "antd";
// hooks
import { useGestionarPostulaciones } from "../../../../hooks/useGestionarPostulaciones";

// components
// icons
import {SearchOutlined } from "@ant-design/icons";
// data select

import "../../Convocatorias/old.scss";
import "./../GestionarPostulaciones/gestionarPostulaciones.scss";
import { BreadCrumbAdmin } from "../../../../components/Administrador/Breadcrumb/Breadcrumb";
import { useMaestras } from "../../../../hooks/useMaestras";
import apiMaestras from "../../../../api/Maestras/api-maestras";
import getStorageUser from "../../../../middlewares/GetStorageUser"
import { lineasVisibles } from "../../../../utils/lineasVisibles";

import { itemRenderTable } from "../../../../utils/itemRenderTable";
import { openNotification } from "../../../../utils/Notifactions";
import {
  esDeclaracionDeResidencia,
  esFormularioEnLinea,
} from "../../../../utils/documentosGrupoConformado";

const TiposIdentificacion: any = {
  "1": "Persona Natural",
  "3": "Grupo Conformado",
  "2": "Persona Juridica",
};

const TipoDocumento: any = {
  "1": "CC",
  "3": "CC",
  "2": "NIT",
}

/**
 * Los participantes de unas postulaciones, uno por fila.
 *
 * Vive fuera del componente porque la usan dos: la tabla, con lo que haya
 * filtrado, y la exportacion, con todas. Si cada una armara su lista, el
 * Excel y la pantalla podrian no decir lo mismo.
 */
const participantesDeLasPostulaciones = (postulaciones: any): any[] => {
  const allpostulaciones = postulaciones;

  if (!allpostulaciones || !Array.isArray(allpostulaciones)) return [];

  // Map to deduplicate proposals and group their participants
  const proposalsById = new Map();

  allpostulaciones
    .filter((postu: any) => postu.tipo_participante == 1 || postu.tipo_participante == 2 || postu.tipo_participante == 3)
    .forEach((postu: any) => {
      if (proposalsById.has(postu.id_postulacion)) return;

      const adminDocs = postu.documentos_administrativos || [];

      // Tipo 1 - Persona Natural: el postulante mismo es el participante
      if (postu.tipo_participante == 1) {
        const declaracionDoc = adminDocs.find((doc: any) => esDeclaracionDeResidencia(doc));
        if (declaracionDoc) {
          console.log(declaracionDoc);
          console.log(postu);
          const rawDoc1 = postu.numero_documento_participante || '';
          const participant = {
            nombresApellidos: postu.nombre_representante || '',
            tipoDocumento: TipoDocumento[String(postu.tipo_participante)] || 'CC',
            numeroDocumento: String(rawDoc1).replace(/[.\s]/g, ''),
            rol: 'Persona Natural',
            ciudad: declaracionDoc.ciudad || postu.ciudad || '',
            telefonoCelular: declaracionDoc.telefono || '',
            correoElectronico: declaracionDoc.correo || postu.correo || '',
          };
          proposalsById.set(postu.id_postulacion, {
            ...postu,
            participantsProcessed: [participant]
          });
        }
        return;
      }

      // Tipo 2 y 3: extraer participantes de los documentos
      const relevantDocs = adminDocs.filter((doc: any) => esFormularioEnLinea(doc));

      const participantsMap = new Map();
      relevantDocs.forEach((doc: any) => {
        let pIdx = 0;
        for (const part of (doc.participantes || [])) {
          const partId = `${part.numeroDocumento || ''}-${part.nombresApellidos || ''}-${pIdx}`;
          if (!participantsMap.has(partId)) {
            participantsMap.set(partId, {
              ...part,
              numeroDocumento: String(part.numeroDocumento || '').replace(/[.\s]/g, ''),
            });
          }
          pIdx++;
        }
      });

      const participants = Array.from(participantsMap.values());
      if (participants.length > 0) {
        proposalsById.set(postu.id_postulacion, {
          ...postu,
          participantsProcessed: participants
        });
      }
    });

  // Convert to flat list for table, preserving groups
  let flatList: any[] = [];
  const sortedProposals = Array.from(proposalsById.values()).sort((a, b) =>
    (a.radicado || '').localeCompare(b.radicado || '')
  );

  let groupCounter = 0;
  sortedProposals.forEach((postu: any) => {
    const participants = postu.participantsProcessed;
    const currentGroupIndex = groupCounter;
    groupCounter++;

    participants.forEach((part: any, pIdx: number) => {
      flatList.push({
        ...part,
        radicado: postu.radicado || '',
        nombre_propuesta: postu.nombre_propuesta || '',
        linea_convocatoria: postu.linea_convocatoria || '',
        tipo_participante_postu: postu.tipo_participante,
        tipo_participante_label: TiposIdentificacion[String(postu.tipo_participante)] || '',
        id_postulacion: postu.id_postulacion,
        groupIndex: currentGroupIndex,
        key: `${postu.id_postulacion}-${pIdx}-${part.numeroDocumento || part.nombresApellidos}`,
        rowSpan: pIdx === 0 ? participants.length : 0
      });
    });
  });

  return flatList;
};

export const GestionarParticipantes = () => {
  let {
    allpostulaciones,
    cargarTodasPostulaciones,
    // categorias,
    obtenerCategoriasLineas,
    filtros,
    setFiltros,
    limpiarFiltros,
    buscarpostulaciones,
    loading
  } = useGestionarPostulaciones();

  const { obtenerLineaConvocatorias, lineaConvocatorias } = useMaestras();
  const [user, setUser] = useState<any>({});

  const getUser = async () => {
    try {
      const _user = getStorageUser()
      setUser(_user)
    } catch (error) {
      console.log(error);
    }
  };

  /*
    Al entrar solo se piden los maestros de los filtros. Traer las casi
    novecientas postulaciones de una dejaba la pantalla colgada un buen
    rato, y para encontrar a una persona no hacen falta todas.
  */
  useEffect(() => {
    getUser();
    obtenerCategoriasLineas();
    obtenerLineaConvocatorias();
  }, []);

  /** Hasta que no se busque algo, la tabla no tiene nada que decir. */
  const [yaSeBusco, setYaSeBusco] = useState(false);

  /**
   * Busca con lo que haya en los filtros.
   *
   * Hace falta el documento o la linea: la categoria sola no acota nada,
   * porque se aplica sobre lo que devuelva una de las dos.
   */
  const buscarParticipantes = async () => {
    const hayPalabra = String(filtros?.buscarpalabra ?? "").trim() !== "";
    const hayLinea = String(filtros?.linea_estrategica ?? "").trim() !== "";

    if (!hayPalabra && !hayLinea) {
      return openNotification({
        titulo: "Falta un filtro",
        descripcion:
          "Busca por documento o elige una línea. Son muchas postulaciones para traerlas todas.",
        placement: "bottomRight",
      });
    }

    setYaSeBusco(true);
    await buscarpostulaciones();
  };

  useEffect(() => {
    // Este useEffect asegurará que el estilo de scroll se mantenga
    const scrollableDiv = document.querySelector('.my-scrollable-div') as HTMLElement;
    if (scrollableDiv) {
      scrollableDiv.style.overflowX = 'auto';
      scrollableDiv.style.whiteSpace = 'nowrap';
    }
  }, []);
  const routes = [{ nombre: "Postulaciones" }, { nombre: "Artistas" }];

  /* **** MODAL **** */
  const [categorias, setCategorias] = useState([]);
  const handleLineaChange = async (id_linea: number | string) => {
    if (typeof id_linea === 'string') {
      // Convierte la cadena a número si es necesario
      id_linea = parseInt(id_linea, 10);
    }

    try {
      const { data } = await apiMaestras.obtenerCategoriasPorLinea(id_linea);
      setCategorias(data);
      setFiltros({
        ...filtros,
        categoria: null,
        linea_estrategica: id_linea,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const processedData = React.useMemo(
    () => participantesDeLasPostulaciones(allpostulaciones),
    [allpostulaciones]
  );

  // xlsx pesa 861 KB y solo hace falta al pulsar este boton: se carga en ese momento
  // para que no viaje en el paquete inicial de la aplicacion.
  const [exportando, setExportando] = useState(false);

  /**
   * El Excel va completo, con todos los participantes.
   *
   * La tabla muestra lo que se haya buscado, pero aqui se piden todas las
   * postulaciones a proposito: exportar solo lo filtrado daria un archivo
   * que parece el listado entero sin serlo.
   */
  const exportarExcel = async () => {
    setExportando(true);
    try {
      await construirExcel();
    } catch (error) {
      console.error("No se pudo exportar", error);
      openNotification({
        titulo: "Error",
        descripcion: "No se pudo generar el archivo. Intenta de nuevo.",
        placement: "bottomRight",
      });
    } finally {
      setExportando(false);
    }
  };

  const construirExcel = async () => {
    const XLSX = await import("xlsx");

    const todas = await cargarTodasPostulaciones(false, "general");
    const participantes = participantesDeLasPostulaciones(todas);
    if (participantes.length === 0) return;

    const rows = participantes.map((record: any) => ({
      "Radicado": record.radicado || '',
      "Proyecto": record.nombre_propuesta || '',
      "Línea convocatoria": record.linea_convocatoria || '',
      "Tipo Participante": record.tipo_participante_label || '',
      "Participante": record.nombresApellidos || '',
      "Tipo Doc.": record.tipoDocumento || '',
      "Documento": record.numeroDocumento || '',
      "Rol": record.rol || '',
      "Ciudad": record.ciudad || '',
      "Teléfono": record.telefonoCelular || '',
      "Correo": record.correoElectronico || '',
    }));

    const worksheet = XLSX.utils.json_to_sheet(rows);
    worksheet['!cols'] = [
      { wch: 14 }, { wch: 50 }, { wch: 40 }, { wch: 18 }, { wch: 35 }, { wch: 10 },
      { wch: 16 }, { wch: 30 }, { wch: 18 }, { wch: 14 }, { wch: 32 }
    ];
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Participantes");
    XLSX.writeFile(workbook, "Participantes.xlsx");
  };


  const participantColumns: any = [
    {
      title: "No.",
      width: 40,
      render: (datos: any, record: any, idx: number) => <div>{idx + 1}</div>,
    },
    {
      title: "Radicado",
      dataIndex: "radicado",
      key: "radicado",
      width: 120,
      render: (text: string) => <strong>{text}</strong>,
      onCell: (record: any) => ({
        rowSpan: record.rowSpan,
        style: { verticalAlign: 'middle', textAlign: 'center' }
      })
    },
    {
      title: "Proyecto",
      dataIndex: "nombre_propuesta",
      key: "nombre_propuesta",
      width: 250,
      render: (text: string) => <span style={{ whiteSpace: "pre-line" }}>{text}</span>,
      onCell: (record: any) => ({
        rowSpan: record.rowSpan,
        style: { verticalAlign: 'middle', textAlign: 'center' }
      })
    },
    {
      title: "Línea convocatoria",
      dataIndex: "linea_convocatoria",
      key: "linea_convocatoria",
      width: 200,
      render: (text: string) => <span style={{ whiteSpace: "pre-line" }}>{text}</span>,
      onCell: (record: any) => ({
        rowSpan: record.rowSpan,
        style: { verticalAlign: 'middle' }
      })
    },
    {
      title: "Tipo participante",
      dataIndex: "tipo_participante_label",
      key: "tipo_participante_label",
      width: 130,
      onCell: (record: any) => ({
        rowSpan: record.rowSpan,
        style: { verticalAlign: 'middle', textAlign: 'center' }
      })
    },
    {
      title: "Participante",
      dataIndex: "nombresApellidos",
      key: "nombresApellidos",
      width: 250,
      render: (text: string) => <span style={{ whiteSpace: "pre-line" }}>{text || "N/A"}</span>,
    },
    {
      title: "Tipo Doc.",
      dataIndex: "tipoDocumento",
      key: "tipoDocumento",
      width: 80,
    },
    {
      title: "Documento",
      dataIndex: "numeroDocumento",
      key: "numeroDocumento",
      width: 140,
    },
    {
      title: "Rol",
      dataIndex: "rol",
      key: "rol",
      width: 150,
      render: (text: string) => <span style={{ whiteSpace: "pre-line" }}>{text}</span>,
    },
    {
      title: "Ciudad",
      dataIndex: "ciudad",
      key: "ciudad",
      width: 150,
    },
    {
      title: "Teléfono",
      dataIndex: "telefonoCelular",
      key: "telefonoCelular",
      width: 120,
    },
    {
      title: "Correo",
      dataIndex: "correoElectronico",
      key: "correoElectronico",
      width: 200,
      ellipsis: true,
    }
  ];

  return (
      <div className="background-color-F7FBFF h-100">
        <BreadCrumbAdmin routes={routes} />
        <div className="container-fluid ps-md-4 pe-md-4 main-c">
          <div className="title_out_card font-family-Montserrat-SemiBold font-size-14px">
            Gestionar participantes
          </div>

          <div className="sombra_card" style={{ marginBottom: "20px" }}>
            <div>
              <div className="header_card">
                <div className="title_in_card font-size-14px font-color-1B1C1D font-family-Montserrat-Regular">
                  Filtrar participantes
                </div>
              </div>
              <div className="body_card">
                <div className="row">
                  <div className="col-12 col-md-6 col-lg-3">
                    <div className="row">
                      <div className="col-12 pb-2">
                        <span className="font-size-12px font-family-Montserrat-SemiBold font-color-4B4B4B">
                          Filtrar por palabra
                        </span>
                      </div>
                      <div className="col-12 pb-2">
                        <Input
                          value={filtros.buscarpalabra}
                          suffix={
                            <SearchOutlined className="font-color-051923bf" />
                          }
                          onChange={(e) =>
                            setFiltros({
                              ...filtros,
                              buscarpalabra: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row mb-3">
                    <div className="col-12 pb-2 ">
                      <span className="font-size-12px font-family-Montserrat-SemiBold font-color-4B4B4B">
                        Filtrar línea
                      </span>
                    </div>
                    <div className="col-12">
                      <Select
                        showSearch
                        value={filtros.linea_estrategica}
                        optionFilterProp="children"
                        style={{ width: "100%" }}
                        placeholder="Seleccionar..."
                        onChange={(value: any) => handleLineaChange(value)}
                      >
                        {lineasVisibles(lineaConvocatorias, user.documento).map(({ id, nombre }: any) => (
                          <Select.Option key={id} value={id}>{nombre}</Select.Option>
                        ))}
                      </Select>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="row">
                      <div className="col-12 pb-2 ">
                        <span className="font-size-12px font-family-Montserrat-SemiBold font-color-4B4B4B">
                          Filtrar categoría
                        </span>
                      </div>
                      <div className="col-12">
                        <Select
                          style={{ width: "100%" }}
                          placeholder="Seleccionar..."
                          onChange={(value: any, option: any) =>
                            setFiltros({ ...filtros, categoria: option.children })
                          }
                        >
                          {categorias.map(({ id, nombre }: any) => (
                            <Select.Option key={id} value={id}>
                              {nombre}
                            </Select.Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                  </div>
                  {/*
                  <div className="col-12 col-md-6 col-lg-2">
                    <div className="row">
                      <div className="col-12 pb-2 ">
                        <span className="font-size-12px font-family-Montserrat-SemiBold font-color-4B4B4B">
                          Filtrar estado
                        </span>
                      </div>
                      <div className="col-12">
                        <Select
                          allowClear
                          style={{ width: "100%" }}
                          placeholder="Seleccionar..."
                          onChange={(value: any) =>
                            setFiltros({ ...filtros, estado: value })
                          }
                        >
                          {EstadosPostulacion.map(({ value, text }) => (
                            <Select.Option key={value} value={value}>
                              {text}
                            </Select.Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-2">
                    <div className="row">
                      <div className="col-12 pb-2 ">
                        <span className="font-size-12px font-family-Montserrat-SemiBold font-color-4B4B4B">
                          Filtrar Año
                        </span>
                      </div>
                      <div className="col-12">
                        <Select
                          allowClear
                          style={{ width: "100%" }}
                          placeholder="Seleccionar..."
                          options={years}
                          onChange={(value: any) =>
                            setFiltros({ ...filtros, anio: value })
                          }
                        >
                        </Select>
                      </div>
                    </div>
                  </div>
                  */}
                </div>
              </div>
            </div>

            <div className="footer_card justify-content-flex-end">
              <Button
                className="button-azul-ghost m-2"
                onClick={() => {
                  setYaSeBusco(false);
                  limpiarFiltros();
                }}
              >
                Limpiar Filtros
              </Button>
              <Button
                className="button-azul-radius m-2"
                onClick={buscarParticipantes}
              >
                Buscar
              </Button>
              <Button
                className="button-azul-radius m-2"
                onClick={exportarExcel}
                disabled={exportando}
                style={{ background: '#217346', borderColor: '#217346' }}
              >
                {exportando ? "Generando…" : "📅 Exportar Excel"}
              </Button>
            </div>
          </div>


          <div className="row-shadow participantes-table">
            <Table
              className="height-30"
              style={{ borderTop: "1px solid #C4C4C4", background: "white" }}
              locale={{
                emptyText: (
                  <Empty
                    description={
                      yaSeBusco
                        ? "No se han encontrado participantes para los filtros seleccionados"
                        : "Busca por documento o elige una línea para ver los participantes"
                    }
                    style={{ padding: "50px" }}
                  />
                ),
              }}
              pagination={{
                position: ["bottomRight"],
                itemRender: itemRenderTable,
                pageSize: 20,
              }}
              dataSource={processedData}
              columns={participantColumns}
              size="small"
              bordered
              loading={loading}
              scroll={{ x: 1600 }}
              rowClassName={(record: any) => record.groupIndex % 2 === 1 ? 'odd-row-group' : 'even-row-group'}
              rowKey={(record) => record.key}
            />
          </div>
        </div>
      </div>
  );
};
